import { ScheduleStatusBind } from 'common/utils/bindScheduleStatus'

export function getScheduleStatus(status: string) {
  return ScheduleStatusBind[status]
}
